module.exports = __webpack_public_path__ + "img/shokunin_World_Map.0742e8f1.svg";